import React, { useEffect, useState } from 'react'
import SearchInputBox from 'components/atoms/input/SearchInputBox'
import { Typography, MenuItem, Box, Stack } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import { USER_CONNECTION_RELATIONSHIP } from 'services/constants'
import { StyledSelect } from 'components/atoms/input/StyledInputs'
import ConnectionUserItem from 'components/molecules/myTeam/ConnectionUserItem'
import InCardStack from 'components/atoms/container/InCardStack'
import { useTranslation } from 'react-i18next'
import { getFullName } from 'utils/formatText'
import SwitchIcon from 'components/atoms/SwitchIcon'
import { updatePageState } from 'utils/windowHistoryHelper'

const seniorRelationships = [
  USER_CONNECTION_RELATIONSHIP[1].value,
  USER_CONNECTION_RELATIONSHIP[2].value
]
const otherRelationships = [USER_CONNECTION_RELATIONSHIP[4].value]
const colleagueRelationship = [USER_CONNECTION_RELATIONSHIP[3].value]
const reportRelationship = [USER_CONNECTION_RELATIONSHIP[0].value]

const TeamView = ({ userConnections, addConnectionButton }) => {
  const { t } = useTranslation()
  const [filterText, setFilterText] = useState('')
  const [selectedRole, setSelectedRole] = useState(
    window.history?.state?.selectedRole === ''
      ? ''
      : window.history?.state?.selectedRole ||
          USER_CONNECTION_RELATIONSHIP[0].value
  )
  const [displayConnections, setDisplayConnections] = useState(userConnections)
  const [treeView, setTreeView] = useState(false)

  useEffect(() => {
    const list = userConnections.filter(
      c =>
        getFullName(c.user, true).toLowerCase().indexOf(filterText) >= 0 &&
        (treeView || selectedRole === '' || c.relationship === selectedRole)
    )
    setDisplayConnections(list)
  }, [userConnections, filterText, treeView, selectedRole])

  useEffect(() => {
    updatePageState({ selectedRole })
  }, [selectedRole])

  const TeamList = ({ title = '', roleList = [], showTitle = true }) => {
    const conns = displayConnections.filter(c =>
      roleList.length > 0 ? roleList.includes(c.relationship) : true
    )
    return (
      <Stack padding={0} spacing={8}>
        {showTitle && (
          <Typography variant='h3'>{`${title} (${conns.length})`}</Typography>
        )}

        {conns.length > 0 ? (
          <RowStack
            spacing={0}
            gap={6}
            style={{
              flexWrap: 'wrap'
            }}>
            {conns.map(c => (
              <Box key={c.id}>
                <ConnectionUserItem c={c} />
              </Box>
            ))}
          </RowStack>
        ) : (
          <>
            {title && (
              <Typography>
                {t('myTeam.haveNoTypeConnections', { type: title })}
              </Typography>
            )}
            <Box>
              <ConnectionUserItem showSkeleton={true} />
            </Box>
          </>
        )}
      </Stack>
    )
  }

  return (
    <>
      <RowStack spacing={0} justifyContent={'space-between'}>
        <RowStack spacing={4} width='unset'>
          <SearchInputBox
            onChangeHandler={e => setFilterText(e.target.value.toLowerCase())}
            placeholder={t('myTeam.searchConnection')}
            style={{ padding: 0 }}
            inputSx={{
              width: 320
            }}
          />

          {!treeView && (
            <StyledSelect
              sx={{ minWidth: 240 }}
              displayEmpty
              value={selectedRole}
              onChange={e => setSelectedRole(e.target.value)}>
              <MenuItem value=''>{t('myTeam.allConnections')}</MenuItem>
              {USER_CONNECTION_RELATIONSHIP.map(item => (
                <MenuItem key={item.value} value={item.value}>
                  {t(`constants.userConnRelationshipPlural.${item.value}`)}
                </MenuItem>
              ))}
            </StyledSelect>
          )}
        </RowStack>

        <RowStack width={232}>
          <SwitchIcon active={treeView} setActive={setTreeView} />
          {addConnectionButton}
        </RowStack>
      </RowStack>

      {!treeView ? (
        <TeamList
          title={
            selectedRole.length > 0
              ? t(`constants.userConnRelationship.${selectedRole}`)
              : undefined
          }
          showTitle={false}
        />
      ) : (
        <InCardStack spacing={12} alignItems={'flex-start'}>
          <TeamList
            title={t('myTeam.myReports')}
            roleList={reportRelationship}
          />

          <TeamList
            title={t('myTeam.myManagersSeniorLeaders')}
            roleList={seniorRelationships}
          />

          <TeamList
            title={t('myTeam.myColleagues')}
            roleList={colleagueRelationship}
          />

          <TeamList title={t('myTeam.other')} roleList={otherRelationships} />
        </InCardStack>
      )}
    </>
  )
}

export default TeamView
